import React, { Component } from "react";
import AuthService from '../../services/login/auth.service';

function App(props) {
  var usuario = AuthService.getBasicSocio()
  return (
    <div>
      <small className="acceso">Socio {usuario.numeroSocio}</small>  
      <h6 className="texto-normal">{usuario.nombreCompleto}</h6> 
    </div>
  ) 
}
 
export default App;